
export enum TipoUsuario {
  PESSOA = 'PESSOA',
  EXTRATOR = 'EXTRATOR',
  SISTEMA = 'SISTEMA',
}
